import React from "react";
import Checkbox from "rsuite/es/Checkbox";

import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";


export default ({
    filter,
    onChangeFilter
}) => {
    return (
        <>
            <FlexGrid align="middle">
                <FlexGridItem>
                    <Checkbox
                        name="processed"
                        onChange={(_, checked) => { onChangeFilter({ processed: checked }) }}
                        defaultChecked={filter.processed}
                    >
                        Show processed
                    </Checkbox>
                </FlexGridItem>
            </FlexGrid>
        </>
    );
};